// Config for Contact Form widget.
// Name, email, phone, message fields with submit.

export type ContactFormField = 'name' | 'email' | 'phone' | 'subject' | 'message';

export type ContactFormConfig = {
  _type: 'contact_form';
  heading_ar?: string;
  heading_en?: string;
  subtitle_ar?: string;
  subtitle_en?: string;
  fields: ContactFormField[];
  required_fields: ContactFormField[];
  submit_label_ar: string;
  submit_label_en: string;
  success_message_ar: string;
  success_message_en: string;
  recipient_email?: string;
  button_color: 'primary' | 'accent' | 'default';
  style: 'default' | 'card';
  align: 'start' | 'center';
};

export const DEFAULT_CONTACT_FORM_CONFIG: ContactFormConfig = {
  _type: 'contact_form',
  heading_ar: 'تواصل معنا',
  heading_en: 'Get in Touch',
  subtitle_ar: 'سنرد عليك في أقرب وقت',
  subtitle_en: "We'll get back to you as soon as possible",
  fields: ['name', 'email', 'phone', 'subject', 'message'],
  required_fields: ['name', 'email', 'message'],
  submit_label_ar: 'إرسال',
  submit_label_en: 'Send Message',
  success_message_ar: 'تم إرسال رسالتك بنجاح!',
  success_message_en: 'Your message has been sent!',
  button_color: 'primary',
  style: 'default',
  align: 'center',
};

export const CONTACT_FORM_FIELDS: { key: ContactFormField; label_en: string; label_ar: string; type: string }[] = [
  { key: 'name', label_en: 'Name', label_ar: 'الاسم', type: 'text' },
  { key: 'email', label_en: 'Email', label_ar: 'البريد الإلكتروني', type: 'email' },
  { key: 'phone', label_en: 'Phone', label_ar: 'الهاتف', type: 'tel' },
  { key: 'subject', label_en: 'Subject', label_ar: 'الموضوع', type: 'text' },
  { key: 'message', label_en: 'Message', label_ar: 'الرسالة', type: 'textarea' },
];
